import { ApiProperty } from "@nestjs/swagger";
import { FuleMeasuredInEnum, FuleTypeEnum, VehicleStatusenum, VehicleTypeEnum } from "@project-management-system/shared-models";

export class VehicleDto {

    @ApiProperty()
    id: number

    @ApiProperty()
    vehicleType: VehicleTypeEnum;

    @ApiProperty()
    vehicleCapacity: number;

    @ApiProperty()
    vehicleName: string;

    @ApiProperty()
    markOrModel: string;


    @ApiProperty()
    markModelId: number;


    @ApiProperty()
    plantId: number;

    @ApiProperty()
    vehicleCategory: number;

    @ApiProperty()
    yearofManufacture: Date | string;
    
    // @ApiProperty()
    // upload: string;
    
    // @ApiProperty()
    // status: string;
    
    @ApiProperty()
    registrationNumber: string;

    @ApiProperty()
    engineNumber: string;

    @ApiProperty()
    chassisNumber: string;

    @ApiProperty()
    fuleType: FuleTypeEnum;

    @ApiProperty()
    fuelMesureMentIn: FuleMeasuredInEnum;

    // @ApiProperty()
    // trackUsageAs: string;

    @ApiProperty()
    secondaryOrAuxilaryMeter: string;

    @ApiProperty()
    vehicleStatus: VehicleStatusenum;

    @ApiProperty()
    insuranceNumber: string;

    // @ApiProperty()
    // insuranceStartDate: string;

    @ApiProperty()
    insuranceExpiryDate: Date | string;

    @ApiProperty()
    roadTexNo: string;

    @ApiProperty()
    roadTexLastDate: Date | string;

    @ApiProperty()
    nationalPermitNo: string;

    @ApiProperty()
    nationalPermitLastDate: Date | string;

    @ApiProperty()
    vehicleLastServicingDate: Date | string;

    @ApiProperty()
    vehicleServicingDate: Date | string;

    @ApiProperty()
    fileName: string;

    @ApiProperty()
    filePath: string;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;


}